<script>

export default {
  name: "ShowPasswordModal",
  components: {
  },
  props: {
    title: String,
    password: String,
    showModal: Boolean,
  },
  methods: {
    close() {
      this.$emit('closed');
    },
  },
}
</script>

<template>
  <span>
    <b-modal @hidden="close" v-model="showModal" :title="title" size="md" centered hide-footer>
      <div class="">
        <div class="row mb-3">
          <div class="col-12">
            Lozinka kreiranog korisnika je: {{ this.password }}
          </div>
        </div>
      </div>

      <div class="form-group text-right mt-3">
        <div class="row align-items-middle justify-content-middle">
          <div class="col-12">
            <b-button @click="close" variant="primary" class="btn px-4 ml-2" >Ok</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<style scoped>
.price-item {
  background-color: #fbfbfb;
  box-shadow: 0px 0px 0px #ffffff;
  border-radius: 4px;
}

.tab-section {
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #f6f6f6;
  margin-bottom: 0px;
  margin-top: 0px;
}

.tab-section:last-child {
  border: 0px;
}

.price-container {
  width: 170px;
}

.sum-section {
  margin-right: 5px;
  border-top: 2px solid #f6f6f6;
  padding-top: 10px;
}

.total-price {
  position: relative;
}

.tab-section h5 {
  font-size: 0.9rem;
}

.pricing-header-row {
  border-bottom: 2px solid #f6f6f6;
  border-radius: 2px;
}

.social-image-container {
  height: 30px;
}

.autocomplete {
  width: 100%;
}
</style>
